<template>
  <div class="user-progress-page-component-container">
    <div class="component-wrapper">
      <AppHeader v-if="!openPageUsingexternalLink"/>
      <div class="user-progress-page-container">
        <div v-if="!isLoaded" class="loading-spinner-container">
          <div class="spinner">
            <img src="../../assets/imgs/loading_spinner.png" alt="Spinner Image">
          </div>
        </div>
        <div v-else-if="openPageUsingexternalLink && errorMsgLoadingPageFromExternalLink" class="error-loading-page-from-external-link-container">
          <div class="error-msg-container">
            <p class="error-msg">{{ errorMsgLoadingPageFromExternalLink }}</p>
          </div>
        </div>
        <div v-else class="swip-page" v-touch:swipe.left="swipeLeft" v-touch:swipe.right="swipeRight">
          <!-- <Loader v-if="!isLoaded" /> -->
          <!-- <ErrorPage v-if="errorMessage" :errorMessage="errorMessage" /> -->
          <FAQ v-if="isLoaded" :visible="FAQ" @show-FAQ="showFAQ(true)" />
          <!-- <Header v-if="isLoaded && !visible && !errorMessage && !FAQ" :profilePhoto="memberPhoto" :user="member.firstName"
            :session="member.nrRegisteredSessions" :totalProgress="totalProgress" :home="home" :machine="machine"
            :activity="activity" /> -->

          <Footer @toggle-component="togglePages" @show-FAQ="showFAQ" v-if="!errorMessage && footer && isLoaded" :home="home"
            :activity="activity" :machine="machine" />
          
          <div class="cards-page-container scroll-bar" v-if="home && isLoaded && !errorMessage" :class="homeSlider">
            <div class="flex-card" v-if="machines.length && activities.length">
              <Card class="cards" :item="machines[0].name" :score="machines[0].score" :title="$t('bestMachine')"
                @toggle-component="togglePages('machine')" :photo="bestMachinePhoto" :imageWidth="'60px'" />
              <Card class="cards" :photo="bestActivityPhoto" :item="$t(activities[0].name.toLowerCase())"
                :score="activities[0].score" :title="$t('bestActivity')" @toggle-component="togglePages('activity')" />
            </div>
            <GraphTitleFAQ v-if="onChangeTotalProgress && onChangeTotalProgress.datasets"
              :totalSessions="totalProgress.labels.length" @change-session="changeSessions"
              :sessions="onChangeTotalProgress.datasets[0].data" />
            <div class="main-chart fit20-font">
              <MainChart :chartdata="onChangeTotalProgress" :options="options" :home="home" />
              <p class="motivation-message">
                {{ $t(randomMsg()) }}
              </p>
            </div>
            <div v-if="onChangeTotalProgress && onChangeTotalProgress.datasets">
              <ChartButton v-for="(item, index) in onChangeTotalProgress.datasets" :key="index" :index="index"
                :machineName="item.label" @toggle-line="toggleLine(index)" :backgroundColor="setBtnStyle(index)" />
            </div>
          </div>

          <div class="activity-page" v-if="activity">
            <Activities :photos="activityPhoto" :activities="activities" />
          </div>

          <div v-if="machine" class="machine-page scroll-bar">
            <SingleMachine v-for="(machine, index) in machines" :key="machine.id" :visible="visible"
              :visibleIndex="visibleIndex" :index="index" @modal-toggle="renderSingleMachinePage"
              @close-pop="closeSingleMachine" @change-singel-machine-session="changeSingleMachineSessions"
              :title="machine.name" :photo="machinesPhoto[`${machine.id}`]" :singelChartdata="SingleMachineChartData"
              :options="options" :machine="machine" :machinesInfo="machinesInfo" :totalProgress="totalProgress"
            />
            <div class="card-page-animation">
              <Machines @render-single-machine-page="renderSingleMachinePage" :machinesData="machines"
                :photo="machinesPhoto" />
            </div>
          </div>
        </div>
      </div>
      <AppFooter v-if="!openPageUsingexternalLink"/>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import AppHeader from '../home/AppHeader';
import AppFooter from '../home/AppFooter';
import MainChart from './MainChart';
import Loader from './Loader';
import Header from './Header';
import Footer from './Footer';
import Card from './Card';
import Machines from './Machines';
import ChartButton from './ChartButton';
import ErrorPage from './ErrorPage';
import Activities from './Activities';
import SingleMachine from './SingleMachine';
import GraphTitleFAQ from './GraphTitle&FAQ';
import FAQ from './FAQ';
// import i18n from '../../internationalization/i18n';
import { colors, dataSetsForMainChart, chartOption } from '../../store';
import { renderSingleMachinePage, changeSingleMachineSessions } from '../../actions/machinesActions';
import {
  // fetchingData,
  // getUserlanguage,
  setTotalProgressAndscoreByMachine,
  setActivities,
  setMachines,
  setDataForMainChart,
  getBestMachinePhoto,
  setMachinesInfo,
  getBestActivityPhoto,
  // GetMemberPhoto,
  getMachinesPhoto,
  getActivitiesPhoto,
  // getProgressAppTranslation,
} from '../../actions/onloadActions';
import { fetchProgressData } from '../../actions/userActions';

export default {
  name: 'UserProgressPage',
  components: {
    AppHeader,
    AppFooter,
    Activities,
    MainChart,
    Loader,
    Header,
    Footer,
    Card,
    ChartButton,
    ErrorPage,
    SingleMachine,
    GraphTitleFAQ,
    Machines,
    FAQ,
  },
  data() {
    return {
      randomNum: null,
      homeSlider: '',
      login: false,
      footer: true,
      bestActivityPhoto: '',
      bestMachinePhoto: '',
      FAQ: false,
      visible: false,
      visibleIndex: '',
      machinesInfo: {},
      singleChartData: '',
      SingleMachineChartData: '',
      errorMessage: '',
      home: true,
      activity: false,
      machine: false,
      isLoaded: false,
      member: '',
      memberPhoto: '',
      allData: false,
      machines: [],
      activities: [],
      activityPhoto: {},
      report: '',
      machinesPhoto: {},
      chartLinesColors: null,
      scoreByMachine: {},
      totalProgress: null,
      onChangeTotalProgress: null,
      totalProgressLabels: null,
      totalProgressDatasets: null,
      isDevMode: process.env.NODE_ENV === 'development',
      error: '',
      options: null,
      openPageUsingexternalLink: false,
      errorMsgLoadingPageFromExternalLink: false,
    };
  },
  methods: {
    setBtnStyle(index) {
      let btnStyle;
      if (this.onChangeTotalProgress.datasets[index].hidden) {
        btnStyle = [{ 'background-color': 'white', 'border': 'solid 2px ' + this.chartLinesColors[index], 'color': this.chartLinesColors[index] }];
      } else {
        btnStyle = [{ 'background-color': this.chartLinesColors[index], 'border': 'solid 2px ' + this.chartLinesColors[index], 'color': 'white' }]
      }
      return btnStyle;
    },
    randomMsg() {
      const randomNum = Math.floor(Math.random() * 15) + 1;
      if (!this.randomNum && typeof this.randomNum != 'number') {
        this.randomNum = randomNum;
        return 'motivationMsg' + randomNum;
      }
      return 'motivationMsg' + this.randomNum;
    },
    showFAQ(close) {
      this.FAQ = !this.FAQ;
      if (close) {
        this.home = true;
      } else {
        this.home = false;
        this.machine = false;
        this.activity = false;
      }
      this.footer = !this.footer;
      setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 400);
    },

    renderSingleMachinePage(index) {
      this.visible = !this.visible;
      this.visibleIndex = index;
      this.SingleMachineChartData = renderSingleMachinePage(this.visibleIndex, this.totalProgress);
      this.singleChartData = this.SingleMachineChartData;
      this.changeSingleMachineSessions(25);
    },
    changeSingleMachineSessions(numberOfSessions) {
      this.SingleMachineChartData = changeSingleMachineSessions(
        numberOfSessions,
        this.singleChartData,
      );
    },
    closeSingleMachine(index) {
      this.visible = !this.visible;
      this.visibleIndex = index;
    },
    togglePages(key) {
      setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 400);
      if (key == 'activity') {
        this.home = false;
        this.machine = false;
        this.activity = true;
      } else if (key == 'home') {
        if (this.activity) {
          this.homeSlider = 'card-page-animation';
        } else if (this.machine) {
          this.homeSlider = 'activity-page';
        } else {
          this.homeSlider = '';
        }
        this.home = true;
        this.activity = false;
        this.machine = false;
        this.changeSessions(this.totalProgress.labels.length);
      } else if (key == 'machine') {
        this.home = false;
        this.activity = false;
        this.machine = true;
      }
    },
    swipeRight() {
      if (this.isLoaded && !this.visible) {
        if (this.home) {
          this.togglePages('machine');
        } else if (this.activity) {
          this.togglePages('home');
        }
      }
    },
    swipeLeft() {
      if (this.isLoaded && !this.visible) {
        if (this.home) {
          this.togglePages('activity');
        } else if (this.machine) {
          this.togglePages('home');
        }
      }
    },
    toggleLine(index) {
      this.onChangeTotalProgress.datasets[index].hidden = !this.onChangeTotalProgress.datasets[
        index
      ].hidden;

      this.totalProgress.datasets[index].hidden = this.onChangeTotalProgress.datasets[index].hidden;

      this.onChangeTotalProgress = {
        labels: this.onChangeTotalProgress.labels,
        datasets: this.onChangeTotalProgress.datasets,
      };
    },
    getMashineName: function (id) {
      let machine = this.allData.machines.find((machine) => machine.id == id && machine.name);

      let machineName = machine ? machine.name : '';
      
      if (machineName == "Lat Pull") {
        machineName = 'Lat Pulldown';
      }
      return machineName;
    },

    getActivityName: function (id) {
      // console.log(id);
      let activityName = this.allData.areas.filter((activity) => activity.order == id)[0]
        .forArea;
      return activityName;
    },
    getActivityURI: function (id) {
      // console.log("this.allData.areas");
      // console.log(this.allData.areas);
      let activityURI = this.allData.areas.filter((activity) => activity.order == id)[0]
        .photoMaleURI;
      // activityURI = activityURI.substr(15, 31);
      return activityURI;
    },
    changeSessions: function (numberOfSessions) {
      // console.log('numberOfSessions: ' + numberOfSessions);
      // console.log("this.totalProgress.labels.length: " + this.totalProgress.labels.length);
      // console.log("this.totalProgress.labels.length - numberOfSessions = " + (this.totalProgress.labels.length - numberOfSessions));
      // console.log(this.totalProgress);
      // console.log(this.totalProgress);
      this.totalProgressLabels =
        numberOfSessions <= 50 && this.totalProgress.labels.length >= 10 && this.totalProgress.labels.length > numberOfSessions
          ? this.totalProgress.labels.slice(this.totalProgress.labels.length - numberOfSessions)
          : this.totalProgress.labels;
      // console.log("this.totalProgressLabels:", this.totalProgressLabels);
      this.totalProgressDatasets = [];
      this.totalProgress.datasets.forEach((item) =>
        this.totalProgressDatasets.push({
          backgroundColor: item.backgroundColor,
          borderColor: item.borderColor,
          data:
            numberOfSessions <= 50 && item.data.length >= 10 && this.totalProgress.labels.length > numberOfSessions
              ? item.data.slice(item.data.length - numberOfSessions)
              : item.data,
          // data: item.data,
          hidden: item.hidden ? item.hidden : false,
          label: item.label,
        }),
      );
      this.onChangeTotalProgress = {
        labels: this.totalProgressLabels,
        datasets: this.totalProgressDatasets,
      };
    },
  },
  async created() {
    // console.log(this.$store.user);
    // const queries = this.$route.query;

    // if (Object.keys(queries).length == 0 || !queries["TA-member-id"] || !queries["TA-studio-id"] || !queries["Access-token"] || !queries["sig"]) {
    //   this.isLoaded = true;
    //   this.errorMessage = 'Missing necessary data!';
    // }
    // else {
    //   try {
    //     this.chartLinesColors = colors;
    //     this.totalProgress = dataSetsForMainChart;
    //     this.options = chartOption;
    //     const langs = ['es', 'nl', 'en', 'fr', 'de', 'en-NZ', 'en-UK', 'nl-BE']
    //     const translation = await getProgressAppTranslation();
    //     this.allData = await fetchingData(false, this);
    //     let language = navigator.language == "en-UK" || navigator.language == "en-NZ" || navigator.language == "nl-BE" ? navigator.language : navigator.language.slice(0, 2);
    //     i18n.locale =
    //       langs.includes(language)
    //         ? language
    //         : langs.includes(getUserlanguage(this.allData, i18n)) ? getUserlanguage(this.allData, i18n) : 'en';

    //     if (translation && Object.keys(translation).length) {
    //       i18n.setLocaleMessage(i18n.locale, translation[i18n.locale]);
    //     }

    //     this.totalProgress.datasets[0].label = this.$t('average');
    //     if (this.allData == 'Server Error' || this.allData == 'Invalid Credentials') {
    //       (this.errorMessage = this.$t('unknownEmailMsg')), (this.isLoaded = true);
    //     } else if (this.allData == 'report Error') {
    //       (this.errorMessage = this.$t('reportErrorMsg')), (this.isLoaded = true);
    //     } else if (this.allData == 'areas Error' || this.allData == 'machines Error') {
    //       (this.errorMessage = this.$t('generalErrorMsg')), (this.isLoaded = true);
    //     } else {
    //       this.report = this.allData.report;
    //       this.member = this.allData.member;
    //       setTotalProgressAndscoreByMachine(this.report, this.scoreByMachine, this.totalProgress);
    //       await setActivities(this.report, this.activities, this.getActivityName);
    //       await setMachines(this.report, this.machines, this.getMashineName);
    //       this.isLoaded = true;
    //       setDataForMainChart(
    //         this.machines,
    //         this.scoreByMachine,
    //         this.totalProgress,
    //         this.chartLinesColors,
    //       );
    //       this.onChangeTotalProgress = this.totalProgress;
    //       setMachinesInfo(this.machines, this.report, this.machinesInfo);
    //       this.bestActivityPhoto = await getBestActivityPhoto(this.getActivityURI, this.activities);
    //       // this.memberPhoto = await GetMemberPhoto(this.member);
    //       this.bestMachinePhoto = await getBestMachinePhoto(this.machines);
    //       this.activityPhoto = await getActivitiesPhoto(this.report, this.getActivityURI);
    //       this.machinesPhoto = await getMachinesPhoto(this.report);
    //     }
    //   } catch (err) {
    //     this.error = err;
    //     // eslint-disable-next-line no-console
    //     console.log(err);
    //   }
    // }

    this.isLoaded = false;

    // Get the query string from the current page URL
    const queryString = window.location.search;

    // Use URLSearchParams to parse the query string
    const params = new URLSearchParams(queryString);

    // Extract individual parameters
    const id = params.get('id');
    const api_key = params.get('api_key');

    // console.log("id: " + id);
    // console.log("api_Key: " + api_key);

    try {
      if (!this.$store.user.progressData) {
        let progressDataResponse;
        if (id && api_key) {
          this.openPageUsingexternalLink = true;
          const dateObj = {
            id: id,
            api_key: api_key,
          }
          progressDataResponse = await fetchProgressData(dateObj);

          // console.log(progressDataResponse.data);

        }
        else {
          const localStorageUser = JSON.parse(localStorage.getItem('user'));
          if (!localStorageUser || !localStorageUser.email || !localStorageUser.token) {
            this.$store.showErrorPopup = true;
            this.$store.errorPopupTitle = 'logout';
            this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
            this.$store.mustLogOut = true;
          }
          else {
            const { email, token } = localStorageUser;
            const userAuth = await this.$store.authUser(email, token);
            if (!userAuth.status) {
              if (userAuth.confirmWarning) {
                this.$store.unconfirmedAccount = true;
                this.$store.showFooterBackBtn = true;
                this.$store.user.email = email;
                this.$router.push('/confirm');
              }
              else if (userAuth.error) {
                this.$store.showMainErrorPage = true;
              }
              else {
                this.$store.showErrorPopup = true;
                this.$store.errorPopupTitle = 'logout';
                this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
                this.$store.mustLogOut = true;
              }
            }
            else {
              const dateObj = {
                email: email,
                token: token,
              };
              progressDataResponse = await fetchProgressData(dateObj);
            }
          }
        }

        if (progressDataResponse.status) {
          // console.log(dataSetsForMainChart);
          this.$store.user.progressData = progressDataResponse.data;
          this.allData = progressDataResponse.data;
          
          this.chartLinesColors = colors;
          this.totalProgress = dataSetsForMainChart;
          this.options = chartOption;
          // const langs = ['es', 'nl', 'en', 'fr', 'de', 'en-NZ', 'en-UK', 'nl-BE']
          // const translation = await getProgressAppTranslation();

          // let language = navigator.language == "en-UK" || navigator.language == "en-NZ" || navigator.language == "nl-BE" ? navigator.language : navigator.language.slice(0, 2);
          // i18n.locale =
          //   langs.includes(language)
          //     ? language
          //     : langs.includes(getUserlanguage(this.allData, i18n)) ? getUserlanguage(this.allData, i18n) : 'en';

          // if (translation && Object.keys(translation).length) {
          //   i18n.setLocaleMessage(i18n.locale, translation[i18n.locale]);
          // }

          this.totalProgress.datasets[0].label = this.$t('average');
          if (this.allData == 'Server Error' || this.allData == 'Invalid Credentials') {
            (this.errorMessage = this.$t('unknownEmailMsg')), (this.isLoaded = true);
          }
          else if (this.allData == 'report Error') {
            (this.errorMessage = this.$t('reportErrorMsg')), (this.isLoaded = true);
          }
          else if (this.allData == 'areas Error' || this.allData == 'machines Error') {
            (this.errorMessage = this.$t('generalErrorMsg')), (this.isLoaded = true);
          }
          else {
            this.report = this.allData.report;
            // this.member = this.allData.member;
            // console.log(this.totalProgress);
            setTotalProgressAndscoreByMachine(this.report, this.scoreByMachine, this.totalProgress);
            await setActivities(this.report, this.activities, this.getActivityName);
            await setMachines(this.report, this.machines, this.getMashineName);
            this.isLoaded = true;

            // if (!totalProgress) {
            //   setDataForMainChart(
            //     this.machines,
            //     this.scoreByMachine,
            //     this.totalProgress,
            //     this.chartLinesColors,
            //   );
            // }

            setDataForMainChart(
              this.machines,
              this.scoreByMachine,
              this.totalProgress,
              this.chartLinesColors,
            );

            this.onChangeTotalProgress = this.totalProgress;
            setMachinesInfo(this.machines, this.report, this.machinesInfo);
            this.bestActivityPhoto = getBestActivityPhoto(this.getActivityURI, this.activities);
            // this.memberPhoto = await GetMemberPhoto(this.member);
            this.bestMachinePhoto = getBestMachinePhoto(this.machines);
            this.activityPhoto = getActivitiesPhoto(this.report, this.getActivityURI);
            this.machinesPhoto = getMachinesPhoto(this.report);
          }
        }
        else {
          if (this.openPageUsingexternalLink) {
            // console.log(progressDataResponse);
            this.errorMsgLoadingPageFromExternalLink = progressDataResponse.message;
            // console.log(this.errorMsgLoadingPageFromExternalLink);
            this.isLoaded = true;
          }
          else {
            if (progressDataResponse.noDataFounded) {
              this.$store.errorPopupMsg = progressDataResponse.message;
            }
            else {
              this.$store.errorPopupTitle = 'unexpected_error';
              this.$store.errorPopupMsg = 'something_went_wrong_try_again';
            }
            this.$store.showErrorPopup = true;
          }
          
          /* this.loadingPage = false; */
        }
      }
      else {
        // console.log(dataSetsForMainChart);
        this.allData = this.$store.user.progressData;
        
        this.chartLinesColors = colors;
        this.totalProgress = dataSetsForMainChart;
        this.options = chartOption;
        // const langs = ['es', 'nl', 'en', 'fr', 'de', 'en-NZ', 'en-UK', 'nl-BE']
        // const translation = await getProgressAppTranslation();

        // let language = navigator.language == "en-UK" || navigator.language == "en-NZ" || navigator.language == "nl-BE" ? navigator.language : navigator.language.slice(0, 2);
        // i18n.locale =
        //   langs.includes(language)
        //     ? language
        //     : langs.includes(getUserlanguage(this.allData, i18n)) ? getUserlanguage(this.allData, i18n) : 'en';

        // if (translation && Object.keys(translation).length) {
        //   i18n.setLocaleMessage(i18n.locale, translation[i18n.locale]);
        // }

        this.totalProgress.datasets[0].label = this.$t('average');
        if (this.allData == 'Server Error' || this.allData == 'Invalid Credentials') {
          (this.errorMessage = this.$t('unknownEmailMsg')), (this.isLoaded = true);
        } else if (this.allData == 'report Error') {
          (this.errorMessage = this.$t('reportErrorMsg')), (this.isLoaded = true);
        } else if (this.allData == 'areas Error' || this.allData == 'machines Error') {
          (this.errorMessage = this.$t('generalErrorMsg')), (this.isLoaded = true);
        } else {
          this.report = this.allData.report;
          // this.member = this.allData.member;
          // console.log(this.totalProgress);
          setTotalProgressAndscoreByMachine(this.report, this.scoreByMachine, this.totalProgress);
          await setActivities(this.report, this.activities, this.getActivityName);
          await setMachines(this.report, this.machines, this.getMashineName);
          this.isLoaded = true;
          // if (!totalProgress) {
          //   setDataForMainChart(
          //     this.machines,
          //     this.scoreByMachine,
          //     this.totalProgress,
          //     this.chartLinesColors,
          //   );
          // }

          setDataForMainChart(
            this.machines,
            this.scoreByMachine,
            this.totalProgress,
            this.chartLinesColors,
          );
          
          this.onChangeTotalProgress = this.totalProgress;
          setMachinesInfo(this.machines, this.report, this.machinesInfo);
          this.bestActivityPhoto = getBestActivityPhoto(this.getActivityURI, this.activities);
          // this.memberPhoto = await GetMemberPhoto(this.member);
          this.bestMachinePhoto = getBestMachinePhoto(this.machines);
          this.activityPhoto = getActivitiesPhoto(this.report, this.getActivityURI);
          this.machinesPhoto = getMachinesPhoto(this.report);
        }
      }
    }
    catch(err) {
      console.log(err);
    }
  },
}
</script>

<style>

.user-progress-page-component-container {
  width: 100%;
  height: 100vh;
  position: relative;
  /* border: 1px solid; */
}

.user-progress-page-component-container .component-wrapper {
    height: 100vh;
    display: flex;
    flex-direction: column;
}

.user-progress-page-component-container .user-progress-page-container {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  overflow: hidden;
  /* border: 1px solid red; */
}

.user-progress-page-component-container .loading-spinner-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.user-progress-page-component-container .spinner {
  width: 20% !important;
  max-width: 100px !important;
}

.user-progress-page-component-container .error-loading-page-from-external-link-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.user-progress-page-component-container .error-loading-page-from-external-link-container .error-msg {
  font-size: 28px;
  color: #cb061d;
  font-family: 'VAG Rounded Std', sans-serif;
  font-weight: bold;
}

.user-progress-page-component-container .swip-page {
  position: relative;
  width: 100%;
  height: 100%;
  /* padding: 5px 0; */
}

.user-progress-page-component-container .cards-page-container {
  margin-top: 55px;
  padding: 10px 0 60px;
  height: 100%;
  overflow: auto;
  /* border: 1px solid blue; */
}

.user-progress-page-component-container .motivation-message {
  text-align: center;
  padding: 10px 30px;
  margin-bottom: 5px;
  color: #ffffff;
  background: url('../../assets/muscle2.jpg') center center fixed;
  background-size: contain;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.user-progress-page-component-container canvas {
  max-height: 300px;
}

.user-progress-page-component-container .fade {
  /* opacity: 0.4; */
  /* color: #fdfef9 !important; */
}

.user-progress-page-component-container .activity-page {
  animation: slide linear 0.4s;
  /* padding-top: 60px; */
}

.user-progress-page-component-container .machine-page {
  padding-top: 55px;
  height: 100%;
  overflow: auto;
}

.user-progress-page-component-container .card-page-animation {
  animation: machine-page-slide linear 0.4s;
  /* padding-top: 60px; */
}

@keyframes machine-page-slide {
  0% {
    transform: translate(-100%, 0%);
  }

  10% {
    transform: translate(-90%, 0%);
  }

  20% {
    transform: translate(-80%, 0%);
  }

  30% {
    transform: translate(-70%, 0%);
  }

  40% {
    transform: translate(-60%, 0%);
  }

  50% {
    transform: translate(-50%, 0%);
  }

  60% {
    transform: translate(-40%, 0%);
  }

  70% {
    transform: translate(-30%, 0%);
  }

  80% {
    transform: translate(-20%, 0%);
  }

  90% {
    transform: translate(-10%, 0%);
  }

  100% {
    transform: translate(0%, 0%);
  }
}

@keyframes slide {
  0% {
    transform: translate(100%, 0%);
  }

  10% {
    transform: translate(90%, 0%);
  }

  20% {
    transform: translate(80%, 0%);
  }

  30% {
    transform: translate(70%, 0%);
  }

  40% {
    transform: translate(60%, 0%);
  }

  50% {
    transform: translate(50%, 0%);
  }

  60% {
    transform: translate(40%, 0%);
  }

  70% {
    transform: translate(30%, 0%);
  }

  80% {
    transform: translate(20%, 0%);
  }

  90% {
    transform: translate(10%, 0%);
  }

  100% {
    transform: translate(0%, 0%);
  }
}

@media only screen and (min-width: 770px) {
  .user-progress-page-component-container .cards {
    width: 50%;
  }

  .user-progress-page-component-container .flex-card {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    text-align: center;
    width: 100%;
  }
}

@media (max-width: 425px) {
  .user-progress-page-component-container .error-loading-page-from-external-link-container .error-msg {
    font-size: calc(18px + 2vw);
  }
}
</style>
